export default [{
    label: 'order',
    name: 'orderId',
    width: '',
    exportwidth: '20',
    sortable: true
  },
  {
    label: 'time',
    name: 'createdDate',
    width: '',
    exportwidth: '20',
    sortable: true
  },
  {
    label: 'acc',
    name: 'tradeAccountNumber',
    width: '',
    exportwidth: '20',
    sortable: true
  },
  {
    label: 'amount',
    name: 'amount',
    width: '',
    exportwidth: '20',
    sortable: true
  },
  {
    label: 'fundBankType',
    name: 'fundBankType',
    width: '',
    exportwidth: '20',
    sortable: true
  },
  {
    label: 'status',
    name: 'status',
    width: '',
    exportwidth: '20',
    sortable: true
  },
  {
    label: 'comment',
    name: 'remark',
    width: '',
    exportwidth: '20',
    sortable: true
  }
]
